import { render, staticRenderFns } from "./PaymentWw.vue?vue&type=template&id=6b3f74a4&scoped=true&"
import script from "./PaymentWw.vue?vue&type=script&lang=js&"
export * from "./PaymentWw.vue?vue&type=script&lang=js&"
import style0 from "./PaymentWw.vue?vue&type=style&index=0&id=6b3f74a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3f74a4",
  null
  
)

export default component.exports